import { CDN } from '../consts';

export type MarketingMedia =
  | { type: 'empty'; description: string }
  | { type: 'image'; description: string; src: string }
  | {
      type: 'video';
      description: string;
      src: string;
      mimeType: 'video/webm' | 'video/mp4';
      sources?: { src: string; type: string }[];
      fallbackSrc?: string;
      poster?: string;
    };

/** CDN still for a video's primary source, whether the video is remote or local. */
export function posterForVideoSource(src: string): string {
  const filename = src.split(/[?#]/, 1)[0].split('/').pop()!;
  return `${CDN}${filename.replace(/\.[^.]+$/, '')}.jpg`;
}

export function approvedVideo(
  filename: string,
  description: string,
): Extract<MarketingMedia, { type: 'video' }> {
  return {
    type: 'video',
    description,
    src: `${CDN}${filename}`,
    mimeType: filename.endsWith('.mp4') ? 'video/mp4' : 'video/webm',
    poster: posterForVideoSource(filename),
  };
}

export function approvedVideoSource(filename: string, type: string) {
  return { src: `${CDN}${filename}`, type };
}

export function approvedImage(
  filename: string,
  description: string,
): Extract<MarketingMedia, { type: 'image' }> {
  return { type: 'image', description, src: `${CDN}${filename}` };
}
